import { defineComponent as K, computed as v, ref as Q, createElementBlock as s, openBlock as a, createElementVNode as r, mergeProps as L, createCommentVNode as u, renderSlot as y, createTextVNode as k, toDisplayString as h, normalizeClass as i, createBlock as m, unref as c, withCtx as C, Fragment as w, renderList as T, createVNode as W, withDirectives as X, vShow as Y } from "vue";
import { RevButtonIcon as O } from "@ds/components/ButtonIcon";
import { RevCheckbox as j } from "@ds/components/Checkbox";
import D from "../CheckboxBase/CheckboxBase.vue2.js";
import { RevTooltip as Z } from "@ds/components/Tooltip";
import { usePropsValidation as ee } from "../../composables/usePropsValidation.js";
import le from "../../icons/generated/IconChevronDown.vue2.js";
import te from "../../icons/generated/IconChevronUp.vue2.js";
import oe from "../../icons/generated/IconInfo.vue2.js";
import { tw as o } from "../../utils/tailwind.js";
import ae from "./components/TableSortingHeader.vue2.js";
const de = {
  key: 0,
  class: "heading-2 m-24 text-left"
}, se = { class: "block md:table-row" }, ne = {
  key: 0,
  class: "px-16 text-start first:pl-24",
  scope: "col"
}, re = ["id"], ie = { class: "flex items-center" }, ce = ["id"], ue = ["headers"], pe = ["headers"], be = ["id", "aria-expanded"], fe = { colspan: "100" }, he = ["id", "aria-expanded"], me = { colspan: "100" }, Be = /* @__PURE__ */ K({
  name: "RevTable",
  __name: "Table",
  props: {
    caption: { default: "" },
    checkedIds: { default: void 0 },
    selectAllLabel: { default: "Select All" },
    showCheckboxesLabels: { type: Boolean, default: !1 },
    collection: {},
    getCollectionItemId: { type: Function, default: (I) => typeof I == "object" && I !== null && "id" in I ? I.id : "" },
    columns: {},
    stripedRows: { type: Boolean, default: !1 },
    sortOptions: { default: null },
    transparentHeader: { type: Boolean, default: !1 },
    expandLabel: { default: "Expand" },
    expandRowsByDefault: { type: Boolean, default: !1 },
    shouldMountExpandedRows: { type: Boolean, default: !1 }
  },
  emits: ["update:sortOptions", "update:checkedIds", "update:expandAll", "update:expandedRow"],
  setup(I, { expose: M, emit: S }) {
    const t = I, p = S;
    ee({
      "`props.selectAllLabel` should be provided if `props.checkedIds` was chosen": () => t.checkedIds && !t.selectAllLabel,
      "collection items should have an id property or a `getCollectionItemId` method should be provided if `checkedIds` or `expandable` rows are used": () => t.checkedIds || t.collection.some((e) => e.expandable) ? t.collection.some(
        (e) => t.getCollectionItemId(e) === void 0
      ) : !1
    });
    const g = v(() => ({
      align: "end",
      key: "expand",
      label: t.expandLabel
    })), x = v(
      () => t.collection.length === t.checkedIds?.length
    ), U = v(() => [
      o`border-static-default-low body-1-bold h-56 border-b-1`,
      o`hidden`,
      o`md:table-row-group`,
      t.transparentHeader ? o`bg-transparent` : o`bg-static-default-hi`
    ]), $ = v(() => [
      o`bg-static-default-min`,
      o`mt-24 block`,
      o`md:border-static-default-low md:mt-0 md:table-row md:border-b-1 md:last:border-b-0`,
      t.stripedRows && o`md:even:bg-static-default-mid`
    ]), F = v(() => [
      o`px-16`,
      o`border-static-default-low flex items-center justify-between border-b-1 py-12 before:content-[attr(headers)] first:pl-24`,
      o`md:table-cell md:border-none md:py-24 md:before:content-none`,
      t.stripedRows && o`md:even:bg-static-default-mid`
    ]), _ = (e) => [
      o`px-16 first:pl-24`,
      e.highlighted && o`bg-static-info-low`
    ], A = (e) => [
      o`group`,
      o`border-static-default-low border-b-1 md:border-none `,
      o`before:body-1-bold before:px-16 before:py-12 before:content-[attr(headers)] md:before:content-none`,
      o`flex items-center justify-between md:table-cell`,
      t.stripedRows && !e.highlighted && o`even:bg-static-default-mid md:even:before:bg-static-default-hi even:md:bg-transparent`,
      e.highlighted && o`bg-static-info-low`
    ], z = (e) => [
      o`mr-8 text-left`,
      e.headerClassNames
    ], N = (e) => [
      o`flex items-center px-16 py-12 text-end md:py-24 md:text-start md:group-first-of-type:pl-24 md:group-last-of-type:pr-24`,
      e.isTabular && o`justify-end tabular-nums`,
      !e.isTabular && !e.align && o`justify-start`,
      !e.isTabular && e.align === "start" && o`justify-start`,
      !e.isTabular && e.align === "center" && o`justify-center`,
      !e.isTabular && e.align === "end" && o`justify-end`
    ];
    function H(e) {
      return t.sortOptions?.sortBy === e && t.sortOptions?.sortOrder || "UNDEFINED";
    }
    function P(e, d) {
      p("update:sortOptions", { sortBy: e, sortOrder: d });
    }
    function B() {
      if (x.value)
        p("update:checkedIds", []);
      else {
        const e = t.collection.map(
          (d) => t.getCollectionItemId(d)
        );
        p("update:checkedIds", e);
      }
    }
    function E(e) {
      if (!t.checkedIds)
        return;
      const d = t.getCollectionItemId(e);
      t.checkedIds.includes(d) ? p(
        "update:checkedIds",
        t.checkedIds.filter((l) => l !== d)
      ) : p("update:checkedIds", [...t.checkedIds, d]);
    }
    function q() {
      return t.collection.filter((d) => d.expandable).reduce((d, l) => ({
        ...d,
        [t.getCollectionItemId(l)]: t.expandRowsByDefault
      }), {});
    }
    const b = Q(q()), R = v(() => t.collection.some((e) => e.expandable !== void 0));
    function G(e) {
      const d = !b.value[t.getCollectionItemId(e)];
      b.value[t.getCollectionItemId(e)] = d, p("update:expandedRow", t.getCollectionItemId(e), d);
    }
    const V = (e) => {
      const d = t.collection.filter((l) => l.expandable);
      d.length !== 0 && (b.value = d.reduce(
        (l, f) => ({
          ...l,
          [t.getCollectionItemId(f)]: e
        }),
        {}
      ));
    };
    return M({
      expandAll: () => {
        V(!0), p("update:expandAll", !0);
      },
      collapseAll: () => {
        V(!1), p("update:expandAll", !1);
      }
    }), (e, d) => (a(), s("div", null, [
      r("table", L({
        ...R.value && { "aria-live": "polite" }
      }, { class: "text-static-default-mid body-1 w-full border-collapse border-spacing-0 border-0" }), [
        e.caption ? (a(), s("caption", de, [
          y(e.$slots, "caption", { caption: e.caption }, () => [
            k(h(e.caption), 1)
          ])
        ])) : u("", !0),
        r("thead", {
          class: i(U.value)
        }, [
          r("tr", se, [
            e.checkedIds ? (a(), s("th", ne, [
              e.showCheckboxesLabels ? (a(), m(c(j), {
                key: 1,
                id: "table-select-all",
                "model-value": x.value,
                value: "select-all",
                "onUpdate:modelValue": B
              }, {
                label: C(() => [
                  k(h(e.selectAllLabel), 1)
                ]),
                _: 1
              }, 8, ["model-value"])) : (a(), m(c(D), {
                key: 0,
                id: "table-select-all",
                label: e.selectAllLabel,
                "model-value": x.value,
                value: "select-all",
                "onUpdate:modelValue": B
              }, null, 8, ["label", "model-value"]))
            ])) : u("", !0),
            (a(!0), s(w, null, T(e.columns, (l) => (a(), s("th", {
              id: l.label,
              key: l.key,
              class: i(_(l)),
              scope: "col"
            }, [
              r("div", ie, [
                r("span", {
                  class: i(z(l))
                }, h(l.label), 3),
                l.isSortable ? (a(), m(ae, {
                  key: 0,
                  value: H(l.key),
                  onChange: (f) => P(l.key, f)
                }, null, 8, ["value", "onChange"])) : u("", !0),
                l.description ? (a(), m(c(Z), {
                  key: 1,
                  class: "ml-2"
                }, {
                  trigger: C(({ show: f, hide: n, ...J }) => [
                    W(c(O), L({ icon: c(oe) }, { ref_for: !0 }, J, {
                      size: "small",
                      variant: "secondary",
                      onBlur: n,
                      onFocusin: f,
                      onMouseleave: n,
                      onMouseover: f
                    }), null, 16, ["icon", "onBlur", "onFocusin", "onMouseleave", "onMouseover"])
                  ]),
                  default: C(() => [
                    k(" " + h(l.description), 1)
                  ]),
                  _: 2
                }, 1024)) : u("", !0)
              ])
            ], 10, re))), 128)),
            R.value ? (a(), s("th", {
              key: 1,
              id: g.value.label,
              class: "px-16 text-end",
              scope: "col"
            }, h(g.value.label), 9, ce)) : u("", !0)
          ])
        ], 2),
        r("tbody", null, [
          (a(!0), s(w, null, T(e.collection, (l, f) => (a(), s(w, {
            key: e.getCollectionItemId(l)
          }, [
            r("tr", {
              class: i($.value),
              scope: "row"
            }, [
              e.checkedIds ? (a(), s("td", {
                key: 0,
                class: i(F.value),
                headers: ""
              }, [
                e.showCheckboxesLabels ? (a(), m(c(j), {
                  key: 1,
                  id: `checkbox-${e.getCollectionItemId(l)}`,
                  "model-value": e.checkedIds.includes(e.getCollectionItemId(l)),
                  value: `checkbox-${e.getCollectionItemId(l)}`,
                  "onUpdate:modelValue": (n) => E(l)
                }, {
                  label: C(() => [
                    k(h(
                      // Fallback hardcoded value for backward compatibility
                      l.rowCheckboxLabel || "Select One"
                    ), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "model-value", "value", "onUpdate:modelValue"])) : (a(), m(c(D), {
                  key: 0,
                  id: `checkbox-${e.getCollectionItemId(l)}`,
                  label: l.rowCheckboxLabel || `${l?.title || e.columns[0]?.label || f}-${e.getCollectionItemId(l)}`,
                  "model-value": e.checkedIds.includes(e.getCollectionItemId(l)),
                  value: `checkbox-${e.getCollectionItemId(l)}`,
                  "onUpdate:modelValue": (n) => E(l)
                }, null, 8, ["id", "label", "model-value", "value", "onUpdate:modelValue"]))
              ], 2)) : u("", !0),
              (a(!0), s(w, null, T(e.columns, (n) => (a(), s("td", {
                key: n.key,
                class: i(A(n)),
                headers: n.label
              }, [
                r("div", {
                  class: i(N(n))
                }, [
                  y(e.$slots, `body-${n.key}`, {
                    column: n,
                    item: l
                  }, () => [
                    k(h(l?.[n.key]), 1)
                  ])
                ], 2)
              ], 10, ue))), 128)),
              R.value ? (a(), s("td", {
                key: 1,
                class: i(A(g.value)),
                headers: g.value.label
              }, [
                r("div", {
                  class: i(N(g.value))
                }, [
                  l.expandable ? (a(), m(c(O), {
                    key: 0,
                    "alternative-text": g.value.label,
                    "aria-controls": `expand-${e.getCollectionItemId(l)}`,
                    icon: b.value[e.getCollectionItemId(l)] ? c(te) : c(le),
                    size: "small",
                    variant: "secondary",
                    onClick: (n) => G(l)
                  }, null, 8, ["alternative-text", "aria-controls", "icon", "onClick"])) : u("", !0)
                ], 2)
              ], 10, pe)) : u("", !0)
            ], 2),
            !e.shouldMountExpandedRows && b.value[e.getCollectionItemId(l)] ? (a(), s("tr", {
              key: 0,
              id: `expand-${e.getCollectionItemId(l)}`,
              "aria-expanded": b.value[e.getCollectionItemId(l)],
              class: i($.value)
            }, [
              r("td", fe, [
                y(e.$slots, `expand-${e.getCollectionItemId(l)}`, { item: l })
              ])
            ], 10, be)) : e.shouldMountExpandedRows ? X((a(), s("tr", {
              key: 1,
              id: `expand-${e.getCollectionItemId(l)}`,
              "aria-expanded": b.value[e.getCollectionItemId(l)],
              class: i($.value)
            }, [
              r("td", me, [
                y(e.$slots, `expand-${e.getCollectionItemId(l)}`, { item: l })
              ])
            ], 10, he)), [
              [
                Y,
                e.shouldMountExpandedRows && b.value[e.getCollectionItemId(l)]
              ]
            ]) : u("", !0)
          ], 64))), 128))
        ])
      ], 16)
    ]));
  }
});
export {
  Be as default
};
